import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

const problems = [
  "Inefficient outreach models",
  "Unstructured capital discovery",
  "Closed-network access",
  "Misaligned capital allocation",
];

const ProblemSection = () => {
  return (
    <section className="py-24 md:py-32" aria-label="Problems with traditional fundraising">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl sm:text-4xl font-display font-bold mb-4">
              Fundraising Is <span className="text-destructive">Broken</span>
            </h2>
            <p className="max-w-xl mx-auto text-destructive-foreground">
              Founders spend months pursuing misaligned investors. Investors overlook strong opportunities buried in unstructured outreach.
            </p>
          </motion.div>

          <div className="grid sm:grid-cols-2 gap-4">
            {problems.map((problem, i) => (
              <motion.div
                key={problem}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="flex items-center gap-3 glass rounded-xl p-5"
              >
                <XCircle className="w-5 h-5 text-destructive shrink-0" aria-hidden="true" />
                <span className="text-sm text-muted-foreground">{problem}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
